import React, { useState } from "react";
import {
  Box,
  Flex,
  Text,
  IconButton,
  Button,
  Divider,
  HStack,
  SimpleGrid,
  useBreakpointValue,
  Image
} from "@chakra-ui/react";
import { PlusIcon } from "@heroicons/react/24/outline";
import ButtonUpChevron from "../Images/Button-Up-Chevron-icon-Stande2.0.svg";
import ButtonDownChevron from "../Images/Bottom-Chevron-Icon-Stande2.0.svg";
import PastPaperCardIcon from "../Images/PastPaper-Card-Icon-Stande2.0.svg";
import TopicalQuestionsCardIcon from "../Images/Topical-Questions-Card-Icon-Stande2.0.svg";
import CardArrowIcon from "../Images/Paper-card-arrow.svg";
import { a } from "./appColors";

const ResourceCard = ({ label, icon, onClick }) => {
  return (
    <Flex
      onClick={onClick}
      role="button"
      tabIndex={0}
      w="100%"
      h="116px"
      borderRadius="8px"
      bg={a.materialBg}
      p="16px"
      position="relative"
      _active={{ transform: "scale(0.99)" }}
      _focus={{ boxShadow: "0 0 0 2px rgba(0,0,0,0.08)" }}
      cursor="pointer"
    >
      <Flex direction="column" align="flex-start" gap="8px">
        <Box as="img" className="material-icon" src={icon} alt="" w="24px" h="24px" />
        <Text color={a.materialText} fontSize="14px" fontWeight="400" lineHeight="normal">
          {label}
        </Text>
      </Flex>
      <Box as="img" className="material-icon" src={CardArrowIcon} alt="" w="18px" h="18px" position="absolute" right="10px" bottom="10px" />
    </Flex>
  );
};

const SubjectCard = ({
  subjectName = "Biology (0625)",
  onAddSubject,
  onOpenPastPapers,
  onOpenTopical,
}) => {
  const [open, setOpen] = useState(false);
  const cols = useBreakpointValue({ base: 1, md: 2 });

  return (
    <Box w="100%">
      <Flex
        w="100%"
        p="16px"
        direction="column"
        gap="16px"
        borderRadius="14px"
        border="1px solid" borderColor={a.border}
        bg={a.surface}
        onClick={() => setOpen((s) => !s)}
      >
        <Flex align="center" justify="space-between">
          <Text
            color={a.text2}
            fontFamily='"Mona Sans", sans-serif'
            fontSize="14px"
            fontWeight="500"
            lineHeight="normal"
          >
            {subjectName}
          </Text>
          <Image
              src={open ? ButtonUpChevron : ButtonDownChevron}
              alt=""
              w="20px"
              h="20px"
            />
        </Flex>

        {open && (
          <Box>
            <HStack spacing="14px">
              <Text color={a.text2} fontSize="14px" fontWeight="400" lineHeight="normal">
                Current Resources
              </Text>
              <Divider orientation="vertical" h="17px" borderColor={a.border} />
              <Button
                onClick={onAddSubject}
                variant="ghost"
                h="auto"
                py="2px"
                px="13px"
                gap="4px"
                borderRadius="24px"
                border="1px solid" borderColor={a.border}
                bg="transparent"
                _hover={{ bg: "transparent" }}
                leftIcon={<Box as={PlusIcon} w="14px" h="14px" color={a.text2} />}
              >
                <Text color={a.text2} fontSize="12px" fontWeight="400" lineHeight="normal">
                  Add Subject
                </Text>
              </Button>
            </HStack>

            <SimpleGrid columns={cols} spacing="16px" mt="16px">
              <ResourceCard label="Past Year Papers" icon={PastPaperCardIcon} onClick={onOpenPastPapers} />
              <ResourceCard label="Topical Questions" icon={TopicalQuestionsCardIcon} onClick={onOpenTopical} />
            </SimpleGrid>
          </Box>
        )}
      </Flex>
    </Box>
  );
};

export default SubjectCard;
